import React, { useState } from 'react';
import { Check } from 'lucide-react';
import ContactFormModal from './ContactFormModal';

const HeroSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const bullets = [
    'Protect every message with end-to-end encryption — no third party can ever read your emails',
    'Our zero-knowledge infrastructure means your data stays yours, always and everywhere',
    'Seamlessly integrates with your existing tools while meeting HIPAA, GDPR, and SOC 2 standards',
  ];

  return (
    <>
      <section
        data-testid="hero-section"
        className="relative bg-gradient-to-br from-slate-50 via-white to-blue-50 overflow-hidden"
        style={{ minHeight: 'calc(100vh - 64px)' }}
      >
        {/* Decorative background rectangles */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-32 h-32 border-4 border-blue-700 rounded-lg" />
          <div className="absolute bottom-20 left-1/4 w-24 h-24 border-4 border-emerald-500 rounded-lg" />
          <div className="absolute top-1/3 right-20 w-28 h-28 border-4 border-blue-700 rounded-lg" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex items-center pt-16" style={{ minHeight: 'calc(100vh - 64px)' }}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center w-full">
            {/* Left content */}
            <div className="space-y-8">
              <div>
                <h2
                  className="text-5xl md:text-6xl font-bold leading-tight"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  <span className="text-blue-700">Your Inbox,</span>
                  <br />
                  <span className="text-gray-900">Fortified and Private</span>
                </h2>
              </div>

              <div className="space-y-4">
                {bullets.map((text, i) => (
                  <div key={i} className="flex items-start gap-3 group transition-transform duration-300 hover:translate-x-2">
                    <Check className="h-6 w-6 text-emerald-500 mt-1 flex-shrink-0" strokeWidth={3} />
                    <p className="text-lg text-gray-700">{text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right - Hero image */}
            <div className="relative flex items-center justify-center">
              <div className="relative z-10">
                <img
                  src="https://cdn.pixabay.com/photo/2025/10/08/18/13/cybersecurity-9882101_1280.png"
                  alt="Futuristic digital shield protecting email and data security"
                  className="w-full max-w-lg h-auto drop-shadow-2xl rounded-2xl"
                  data-testid="hero-image"
                />
              </div>

              {/* Background glow effect */}
              <div
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl opacity-20 animate-pulse"
                style={{ animationDuration: '4s' }}
              />
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
        title="Get Started with Guardifix"
      />
    </>
  );
};

export default HeroSection;
